import type { LiveMealEntity } from './LiveMealEntity'

export class LiveMealResponseEntity {
  showCompletedOrderDurationInSecond?: number
  showCanceledOrderDurationInSecond?: number
  meals?: Array<LiveMealEntity> | null
}
